var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHotel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-51.943%",
    y1: "19.883%",
    x2: "100%",
    y2: "74.562%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#223DFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC1AFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "url(#a)",
    opacity: 0.2,
    cx: 8,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8 6.105v-.42h2.4v.42H5.8Zm0 1.263v-.42h2.4v.42H5.8Zm0 1.264V8.21h2.4v.42H5.8Zm0 1.263v-.421h2.4v.42H5.8Zm5.8 1.684V6.737c0-.116-.09-.21-.2-.21h-1.2a.195.195 0 0 0-.141.061.216.216 0 0 0-.059.149v4.842h-.4V4.422A.412.412 0 0 0 9.2 4H4.8a.39.39 0 0 0-.283.124.433.433 0 0 0-.117.298v7.157H4V12h8v-.421h-.4Z",
    fill: "#B41CFF"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel);
export default __webpack_public_path__ + "static/media/hotel.62c2ee0cd2857c9329095132e3e6c1f9.svg";
export { ForwardRef as ReactComponent };